import { render, staticRenderFns } from "./CharacterEmo.vue?vue&type=template&id=57904528&scoped=true"
import script from "./CharacterEmo.vue?vue&type=script&lang=js"
export * from "./CharacterEmo.vue?vue&type=script&lang=js"
import style0 from "./CharacterEmo.vue?vue&type=style&index=0&id=57904528&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57904528",
  null
  
)

export default component.exports